module.exports = __webpack_public_path__ + "img/ribbon.533f28a.png";